type BuildAuthSessionResetUrlOptions = {
  destination?: string
  additionalParams?: Record<string, string>
}

export const buildAuthSessionResetUrl = ({
  destination = 'HOME',
  additionalParams = {},
}: BuildAuthSessionResetUrlOptions = {}) => {
  const searchParams = new URLSearchParams(additionalParams)
  searchParams.delete('authError')
  searchParams.delete('authRetry')
  searchParams.delete('sessionReset')
  searchParams.set('destination', destination)

  return `/api/v2/authentication/reset-session?${searchParams.toString()}`
}
